'use strict';

module.exports = {
  sequenceSVG: require('./sequenceSVG'),
};
